export const MessageIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 42 30">
      <g clipPath="url(#a)">
        <path
          fill="#0C75D7"
          d="M16.403 0h22.601c1.632 0 2.966 1.296 2.966 2.88v9.586c0 1.584-1.334 2.88-2.966 2.88H19.31l-3.945 3.886v-4.03c-1.127-.403-1.928-1.469-1.928-2.707V2.88c0-1.584 1.334-2.88 2.967-2.88z"
        ></path>
        <path
          fill="#fff"
          stroke="#000"
          strokeMiterlimit="10"
          d="M33.34 4.693H4.003C1.87 4.693.148 6.363.148 8.436v12.437c0 2.073 1.72 3.743 3.856 3.743h25.568l5.131 4.98v-5.181c1.454-.547 2.492-1.9 2.492-3.513V8.436c.03-2.073-1.72-3.743-3.856-3.743z"
        ></path>
        <path
          fill="#898989"
          d="M32.508 10.394H4.983v1.612h27.525v-1.612zm0 3.656H4.983v1.612h27.525V14.05zm-13.762 3.628H4.983v1.612h13.763v-1.612z"
        ></path>
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M0 0h42v30H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
};
